import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import SpaceAbsent from '../Absent';

import { ISpace, IShadow } from '../../../../types/space';
import { IDispatch, IRootState } from '../../../../modules/stores';
import { ElementTypes } from '../../../../types/element';

import { SpaceWrapper, SpaceBackConfig } from '../styled';
import { isAbsentField, getForeignTableIdByType } from '../../../../helpers';
import { isDisabledOrDeletedSyncTable } from '../../../../modules/core/helpers';

type IConnectProps = ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>;
interface IProps {
  space: ISpace<ElementTypes>;
  shadow?: IShadow | null;
}

/**
 * This Space is purely for rendering. The user can not do anything until they click into this space,
 * and when that happens, it will switch to SpaceEdit view.
 */
class SpaceView extends React.PureComponent<IProps & IConnectProps> {
  public render() {
    const {
      children,
      fieldAbsent,
      fieldById,
      nodes,
      isEditingMode,
      setEditingSpaceId,
      space,
      shadow,
    } = this.props;
    const posX = !isEditingMode && shadow ? shadow.posX : space.posX;
    const posY = !isEditingMode && shadow ? shadow.posY : space.posY;

    let showAbsentSpace = fieldAbsent;

    if (space.fieldId) {
      const field = fieldById[space.fieldId];

      if (field) {
        const foriegnTableId = getForeignTableIdByType(field);

        if (foriegnTableId) {
          showAbsentSpace =
            showAbsentSpace ||
            !nodes[foriegnTableId] ||
            isDisabledOrDeletedSyncTable(nodes[foriegnTableId].syncTableMeta);
        }
      }
    }

    return (
      <SpaceWrapper
        className={`treelab-space-view ${fieldAbsent ? 'treelab-space-view--absent' : ''}`}
        config={space.config}
        onMouseDown={isEditingMode ? () => setEditingSpaceId(space.id) : () => {}}
        style={{
          borderRadius: '4px',
          cursor: isEditingMode ? 'cursor' : 'inherit',
          overflow: 'hidden',
          position: 'absolute',
          left: `${posX}px`,
          top: `${posY}px`,
          transform: `rotate(${space.rotation}deg)`,
          transformOrigin: `0px 0px`,
          width: `${!isEditingMode && shadow ? shadow.width : space.width}px`,
          height: `${space.isAvoidCollision ? undefined : !isEditingMode && shadow ? shadow.height : space.height}px`,
        }}
      >
        <SpaceBackConfig config={space.config}>
          {showAbsentSpace ? <SpaceAbsent /> : children}
        </SpaceBackConfig>
      </SpaceWrapper>
    );
  }
}

const mapState = ({ core, space: spaceModel }: IRootState, { space }: IProps) => ({
  isEditingMode: spaceModel.isEditingMode,
  fieldAbsent: isAbsentField(space, get(core, `fieldById[${space.fieldId}]`)),
  nodes: core.visibleNodes,
  fieldById: core.fieldById,
});
const mapDispatch = ({ space }: IDispatch) => ({
  setEditingSpaceId: (payload: string) => space.setEditingSpaceId(payload),
});

export default connect(
  mapState,
  // @ts-ignore
  mapDispatch,
)(SpaceView);
